import React from 'react';
// import './style.css'
import logo2 from '../../static/img/logo-2.svg';

export function Success() {

    return (
        <div className='m-5 p-5 f-raleway-m footer footer-logo-text'>
            <label className='footer-button-text'>Поздравляем, оплата прошла успешно.</label><br/><br/>
            Мы уже формируем документы. <br></br>
            Как только они будут готовы, мы направим их вам на почту, указанную в анкете.<br/>Иногда, письма попадают в СПАМ, проверьте соответствующую папку вашего почтового ящика. <br/><br/>
            Вы можете закрыть это окно и дождаться формирования полисов на странице, после чего Вам будет доступна загрузка документов.<br/>
            Копии документом вы всегда найдете в личном кабинете сайта <br></br>
            Пароль от личного кабинета мы направили на вашу электронную почту.<br></br>
            После получения полисов, Вам необходимо направить их в вашу кредитную организацию.<br/><br/>
            Спасибо, что вы с нами.<br/>
            Команда Домстрахование.рф
            <br/>
            <img style={{marginTop: '33px'}} src={logo2} alt="logo" />
        </div>
    )
}
